import React, { forwardRef, useCallback } from 'react';
import { Link as RouterLink, Navigate as RouterNavigate, useNavigate as useRouterNavigate } from 'react-router-dom';
import { routerTarget, mediaUrl } from './siteConfig';

// Older screens supply already-prefixed paths. BrowserRouter owns the prefix;
// normalize both those screens and ordinary app-relative links in one place.
export const Link = forwardRef(({ to, ...props }, ref) => <RouterLink {...props} to={routerTarget(to)} ref={ref} />);
export const Navigate = ({ to, ...props }) => <RouterNavigate {...props} to={routerTarget(to)} />;
export function useNavigate() {
  const navigate = useRouterNavigate();
  return useCallback((to, options) => navigate(routerTarget(to), options), [navigate]);
}

const media = tag => forwardRef(({ src, ...props }, ref) => React.createElement(tag, { ...props, src: mediaUrl(src), ref }));
export const SocialImage = media('img');
export const SocialVideo = media('video');
export const SocialAudio = media('audio');
export const SocialSource = media('source');
